class StoryTabs {
  constructor(element) {
    this.element = element;
    this.tabList = element.querySelector('[role="tablist"]');
    if (!this.tabList) return;
    this.tabs = Array.from(this.tabList.querySelectorAll('[role="tab"]'));
    this.panels = this.tabs.map(tab =>
      document.getElementById(tab.getAttribute('aria-controls'))
    );
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.activateTab(tab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event));
    });
  }

  activateTab(tab) {
    const index = this.tabs.indexOf(tab);
    if (index === -1) return;

    this.tabs.forEach(t => {
      t.classList.remove('story-tabs__tab--active');
      t.setAttribute('aria-selected', 'false');
    });

    this.panels.forEach(panel => {
      panel.classList.remove('story-tabs__card--active');
      panel.hidden = true;
    });

    tab.classList.add('story-tabs__tab--active');
    tab.setAttribute('aria-selected', 'true');
    this.panels[index].classList.add('story-tabs__card--active');
    this.panels[index].hidden = false;
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let newIndex;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        event.preventDefault();
        newIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        event.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    this.tabs[newIndex].focus();
    this.activateTab(this.tabs[newIndex]);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.story-tabs').forEach(element => {
    new StoryTabs(element);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const storyTabs = event.target.querySelector('.story-tabs');
  if (storyTabs) {
    new StoryTabs(storyTabs);
  }
});
